import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);


const index = (resolve) => {
  import('../components/index').then((module) => {
    resolve(module)
  })
}
const blankSwiper = (resolve) => {
  import('../components/component/blankSwiper').then((module) => {
    resolve(module)
  })
}
const exercise = (resolve) => {
  import('../components/exercise').then((module) => {
    resolve(module)
  })
}
const blank1 = (resolve) => {
  import('../components/component/blank1').then((module) => {
    resolve(module)
  })
}
const result = (resolve) => {
  import('../components/result').then((module) => {
    resolve(module)
  })
}
const resultDetail = (resolve) => {
  import('../components/resultDetail').then((module) => {
    resolve(module)
  })
}

const courseDetail = (resolve) => {
  import('../components/course/courseDetail').then((module) => {
    resolve(module)
  })
}
const infoDetail = (resolve) => {
  import('../components/info/infoDetail').then((module) => {
    resolve(module)
  })
}
const consult = (resolve) => {
  import('../components/consult').then((module) => {
    resolve(module)
  })
}

const login = (resolve) => {
  import('../components/isLogin/login').then((module) => {
    resolve(module)
  })
}
const register = (resolve) => {
  import('../components/isLogin/register').then((module) => {
    resolve(module)
  })
}
const foundPassword = (resolve) => {
  import('../components/isLogin/foundPassword').then((module) => {
    resolve(module)
  })
}
const userAgreement = (resolve) => {
  import('../components/userAgreement').then((module) => {
    resolve(module)
  })
};
const activityList = (resolve) => {
  import('../components/activity/activityList').then((module) => {
    resolve(module)
  })
};
const activityDetail = (resolve) => {
  import('../components/activity/activityDetail').then((module) => {
    resolve(module)
  })
};
const infoDownload = (resolve) => {
  import('../components/infoDownload/infoDownload').then((module) => {
    resolve(module)
  })
};
const course = (resolve) => {
  import('../components/course/course').then((module) => {
    resolve(module)
  })
};
const machine = (resolve) => {
  import('../components/machine/machine').then((module) => {
    resolve(module)
  })
};
const newIndex = (resolve) => {
  import('../components/newIndex').then((module) => {
    resolve(module)
  })
};
const newInfoList = (resolve) => {
  import('../components/newInfo/newInfoList').then((module) => {
    resolve(module)
  })
};

const newInfoListAmanda = (resolve) => {
  import('../components/newInfo/newInfoListAmanda').then((module) => {
    resolve(module)
  })
};
const newInfoDetail = (resolve) => {
  import('../components/newInfo/newInfoDetail').then((module) => {
    resolve(module)
  })
};
const newsInformation = (resolve) => {
  import('../components/newInfo/news-information.vue').then((module) => {
    resolve(module)
  })
};
const appShare = (resolve) => {
  import('../components/appShare').then((module) => {
    resolve(module)
  })
};
const search = (resolve) => {
  import('../components/search').then((module) => {
    resolve(module)
  })
};
const giftBag = (resolve) => {
  import('../components/giftBag').then((module) => {
    resolve(module)
  })
};
const order = (resolve) => {
  import('../components/course/order').then((module) => {
    resolve(module)
  })
};

const handbook = (resolve) => {
  import('../components/handbook/handbook').then((module) => {
    resolve(module)
  })
};
const testProfile = (resolve) => {
  import('../components/handbook/testProfile').then((module) => {
    resolve(module)
  })
};
const testClassify = (resolve) => {
  import('../components/handbook/testClassify').then((module) => {
    resolve(module)
  })
};
const testPattern = (resolve) => {
  import('../components/handbook/testPattern').then((module) => {
    resolve(module)
  })
};
const ieltsStructureImg = (resolve) => {
  import('../components/handbook/ieltsStructureImg').then((module) => {
    resolve(module)
  })
};
const siteDetail = (resolve) => {
  import('../components/handbook/siteDetail').then((module) => {
    resolve(module)
  })
};
const aboutUs = (resolve) => {
  import('../components/handbook/aboutUs').then((module) => {
    resolve(module)
  })
};
const downApp = (resolve) => {
  import('../components/handbook/downApp').then((module) => {
    resolve(module)
  })
};
const teacherList = (resolve) => {
  import('../components/teacher/teacherList').then((module) => {
    resolve(module)
  })
};
const teacherDetail = (resolve) => {
  import('../components/teacher/teacherDetail').then((module) => {
    resolve(module)
  })
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/index',
      name: 'index',
      component: index,
      child: [
        {path: '/blankSwiper', component: blankSwiper},
      ]
    },
    {
      path: '/exercise',
      name: 'exercise',
      component: exercise,
      child: [
        {path: '/blank1', component: blank1},
      ]
    },
    {
      path: '/result',
      name: 'result',
      component: result,
    }, {
      path: '/resultDetail',
      name: 'resultDetail',
      component: resultDetail,
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      component: courseDetail,
    }, {
      path: '/infoDetail',
      name: 'infoDetail',
      component: infoDetail,
    }, {
      path: '/consult',
      name: 'consult',
      component: consult,
    },
    {
      path: '/appShare',
      name: 'appShare',
      component: appShare,
    },
    {
      path: '/login',
      name: 'login',
      component: login
    }
    ,
    {
      path: '/register',
      name: 'register',
      component: register
    }
    ,
    {
      path: '/foundPassword',
      name: 'foundPassword',
      component: foundPassword
    }, {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement
    }, {
      path: '/activityList',
      name: 'activityList',
      component: activityList
    }, {
      path: '/activityDetail',
      name: 'activityDetail',
      component: activityDetail
    }, {
      path: '/infoDownload',
      name: 'infoDownload',
      component: infoDownload,
      meta: {
        title: '申友雅思资料库-雅思资料免费领取',
        description: '国内专业英语语言教育机构,专注雅思,留学,GMAT,GRE,等海外留学考试培训班,在上海、北京、广州、武汉、成都、杭州、南京、西安、重庆、深圳等城市均有申友教育的线下中心',
        keywords: '雅思资料，雅思免费资料，雅思资料下载，雅思最新资料，申友雅思，申友雅思资料'
      }
    }, {
      path: '/course',
      name: 'course',
      component: course
    }, {
      path: '/machine',
      name: 'machine',
      component: machine
    }, {
      path: '/',
      name: 'newIndex',
      component: newIndex
    }, {
      path: '/newInfoList',
      name: 'newInfoList',
      component: newInfoList
    }, {
      path: '/newInfoListAmanda',
      name: 'newInfoListAmanda',
      component: newInfoListAmanda
    }, {
      path: '/newInfoDetail/:id',
      name: 'newInfoDetail',
      component: newInfoDetail,
      redirect: {name: 'news-information'},
    },
    {
      path: '/news-information/:id' + '.html',
      name: 'news-information',
      component: newsInformation,
    }, {
      path: '/search',
      name: 'search',
      component: search,
    }, {
      path: '/giftBag',
      name: 'giftBag',
      component: giftBag,
    }, {
      path: '/order',
      name: 'order',
      component: order,
    }, {
      path: '/handbook',
      name: 'handbook',
      component: handbook,
    }, {
      path: '/testProfile',
      name: 'testProfile',
      component: testProfile,
    }, {
      path: '/testClassify',
      name: 'testClassify',
      component: testClassify,
    }, {
      path: '/testPattern',
      name: 'testPattern',
      component: testPattern,
    }, {
      path: '/ieltsStructureImg',
      name: 'ieltsStructureImg',
      component: ieltsStructureImg,
    },
    {
      path: '/siteDetail',
      name: 'siteDetail',
      component: siteDetail,
    }, {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
    }, {
      path: '/teacherList',
      name: 'teacherList',
      component: teacherList,
    }, {
      path: '/teacherDetail',
      name: 'teacherDetail',
      component: teacherDetail,
    }, {
      path: '/downApp',
      name: 'downApp',
      component: downApp,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js